import { util } from 'echarts';
import { ThemeParser } from '../../../core/theme';
import { normalizeToArray } from '../../../util/utils';

export function defaultGrid() {
  const defaultMainGrid = {
    left: 0,
    top: 0,
    right: 0,
    height: 200
  };
  const defaultAttechedGrid = {
    height: 100
  };

  return [defaultMainGrid, defaultAttechedGrid];
}

export function preporcessGrid(option: Parameters<ThemeParser>[0]) {
  option.grid = normalizeToArray(option.grid || {});
}

export function parseGrid(
  option: Parameters<ThemeParser>[0],
  gridConfig: Parameters<ThemeParser>[0]['grid'][]
) {
  (option.grid as unknown as []).forEach((grid, index) => {
    if (grid?.id === 'mainGrid' || index === 0) {
      option.grid[index] = util.merge(util.clone(gridConfig[0]), grid, true);
    } else if (grid.id === 'AttchedGrid' || index > 0) {
      option.grid[index] = util.merge(util.clone(gridConfig[1]), grid, true);
    } else {
      /* empty */
    }
  });
}

export function gridThemeParse(...args: Parameters<ThemeParser>) {
  const [option] = args;
  preporcessGrid(option);
  parseGrid(option, defaultGrid());
}
